import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";
import AddCategory from "../../Modals/addcategory";

const ManageCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // REAL CATEGORY → SUBCATEGORY DATA
  const [rows] = useState([
    {
      id: 1,
      name: "Muscle Group",
      image: "/static/images/placeholder.png",
      subCategories: ["Full Body", "Upper", "Lower", "Core"], // 4
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "Type",
      image: "/static/images/placeholder.png",
      subCategories: [
        "HIIT",
        "Dumbbell Strength",
        "Bodyweight",
        "Abs",
      ], // 4
      createdDate: "03-Sept-2025",
      status: true,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Categories
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Category..."
            />
          </div>

          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
              <AddIcon /> Add Category
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr.</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Sub-Categories</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  {/* Sr No */}
                  <TableCell>{index + 1}</TableCell>

                  {/* Category Name + Image */}
                  <TableCell>
                    <div className="click_action user_block">
                      <figure>
                        <img src={row.image} alt="Category" />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                      </p>
                    </div>
                  </TableCell>

                  {/* Subcategory Count + Button */}
                  <TableCell>
                    <Button
                      className="btn btn_primary sm"
                      onClick={() =>
                        navigate("/manage-categories/manage-sub-categories", {
                          state: { subCategories: row.subCategories, name: row.name },
                        })
                      }
                    >
                      View ({row.subCategories.length})
                    </Button>
                  </TableCell>

                  {/* Created Date */}
                  <TableCell>{row.createdDate}</TableCell>

                  {/* Status Toggle */}
                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  {/* Actions */}
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Add/Edit Category Modal */}
      <AddCategory
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageCategories;
